// @ts-strict-ignore
import { Box, BoxProps } from '@components/gassan-ui/Layout/Box'
import { OldHeading, Image, OldText, breakpoints } from '@gassan-ui'
import { cn } from '@lib/cn'
import { imgix } from '@lib/imigx'
import { TourHighlight } from '@lib/kontent/models/TourHighlight'
import { rgba } from 'polished'
import { FC } from 'react'
import styled, { css } from 'styled-components'

const getItemProps = (index: number, total): BoxProps => {
  const perRow = Math.ceil(total / 2)
  let pt: any = { _: '2rem', medium: '2.5rem', large: 0 }
  if (index < perRow && index > 0) {
    pt = { _: 0, medium: '2.5rem', large: '14rem', xlarge: '14rem' }
  }
  if (index === perRow) {
    pt = { _: 0, medium: '2.5rem', large: '14rem', xlarge: '20rem' }
  }
  if (index > perRow) {
    pt = { _: 0, medium: '2.5rem', large: '14rem', xlarge: '14rem' }
  }
  return {
    pt,
    style: {
      breakInside: 'avoid',
    },
  }
}

const Indicator = styled.div<{ align: string }>`
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  background: #fff;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  display: none;
  ${(p) =>
    p.align === 'left' &&
    css`
      left: calc(-7.5rem - 1px);
    `};
  ${(p) =>
    p.align === 'right' &&
    css`
      right: calc(-7.5rem - 1px);
    `};

  &::before {
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    top: 0.25rem;
    left: 0.25rem;
    border-radius: 1.25rem;
    background: ${(p) => rgba(p.theme.colors.tabaccoBrown, 0.16)};
    content: '';
  }
  &::after {
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    top: 0.75rem;
    left: 0.75rem;
    border-radius: 0.75rem;
    background: ${(p) => p.theme.colors.tabaccoBrown};
    content: '';
  }

  @media screen and (min-width: ${breakpoints.large}) {
    display: block;
  }
`

type Props = TourHighlight & { total: number; index: number }

const Item: FC<Props> = ({ index, total, title, text, image }) => {
  const sources = image.value[0]
    ? [imgix(image.value[0].url, { width: 350 }), imgix(image.value[0].url, { width: 800 })]
    : []
  const perRow = Math.ceil(total / 2)
  const indicatorAlign = index < perRow ? 'right' : 'left'
  return (
    <Box {...getItemProps(index, total)} mb="2rem">
      <Box position="relative">
        <Indicator align={indicatorAlign} />
        <Image
          className={cn('aspect-[20/11]', 'md:aspect-[2/1]')}
          sources={sources}
          placeholder={imgix(image?.value[0]?.url, { width: 50 })}
        />
      </Box>
      <OldHeading variant="h4" mt={{ _: '1rem', medium: '1.5rem', large: '2rem' }} mb=".5rem">
        {title.value}
      </OldHeading>
      <OldText variant="small">{text.value}</OldText>
    </Box>
  )
}

export default Item
